@if (showLoader) {
    <div class="absolute left-0 top-0 z-10 h-full w-full max-w-full">
        <div class="relative h-full w-full max-w-full">
            @switch (loaderType) {
                @case (ViewStackLoaderType.DEFAULT) {
                    <bizz-view-stack-loader></bizz-view-stack-loader>
                }
                @case (ViewStackLoaderType.SKELETON) {
                    <bizz-view-stack-skeleton-loader></bizz-view-stack-skeleton-loader>
                }
            }

        </div>
    </div>
}
@for (item of viewStack; track $index) {
    <div class="absolute left-0 top-0 z-10 h-full w-full max-w-full"
         [ngClass]="{'hidden': (($index < (viewStack.length - 1)) || showLoader) }">
        <div class="relative h-full w-full max-w-full">
            <ng-template viewContainerRef>
            </ng-template>
        </div>
    </div>
}
